export default __webpack_public_path__ + "static/media/countriesVideo.17d69d55.mp4";